import { url, customVariableUrl } from "../config/regex";

const isURL = value =>
  value &&
  (value.match(url) !== null || value.match(customVariableUrl) !== null);

export default isURL;
